module.exports = __webpack_public_path__ + "img/userIcon-1793698374569.png";